/**
 * Post Detail Modal
 * Handles opening and closing the post detail modal
 */
document.addEventListener('DOMContentLoaded', function() {
  // Initialize the modal functionality
  const LDPostModal = {
    modal: null,
    overlay: null,
    closeButton: null,
    isOpen: false,
    currentPost: null,
    currentImageIndex: 0,
    images: [],
    slider: null,
    navButtons: null,
    dotsContainer: null,

    init: function() {
      // Get modal elements
      this.modal = document.getElementById('ld-post-modal');
      
      if (!this.modal) {
        console.error('Post detail modal not found in the DOM');
        return;
      }

      this.overlay = this.modal.querySelector('.ld-post-modal__overlay');
      this.closeButton = this.modal.querySelector('.ld-post-detail__close');
      
      // Get gallery elements
      this.slider = document.getElementById('ld-post-detail-slider');
      this.navButtons = {
        prev: document.getElementById('ld-post-detail-prev'),
        next: document.getElementById('ld-post-detail-next'),
        nav: document.getElementById('ld-post-detail-nav')
      };
      this.dotsContainer = document.getElementById('ld-post-detail-dots');
      
      // Set up event listeners
      this.setupEventListeners();
    },

    setupEventListeners: function() {
      // Close modal when clicking the close button
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.close());
      }
      
      // Close modal when clicking the overlay
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }
      
      // Close modal when pressing ESC key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.close();
        }
      });
      
      // Set up gallery navigation event listeners
      if (this.navButtons.prev) {
        this.navButtons.prev.addEventListener('click', () => this.previousImage());
      }
      if (this.navButtons.next) {
        this.navButtons.next.addEventListener('click', () => this.nextImage());
      }
      
      // Note: Like button event listeners are now set up in updateContent
    },

    open: function(post) {
      if (!this.modal) return;
      
      // Store current post data
      this.currentPost = post;
      
      // Update modal content with post data
      this.updateContent(post);
      
      // Calculate scrollbar width and add padding to prevent page shift
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = scrollbarWidth + 'px';
      
      // Show modal
      this.modal.style.display = 'flex';
      document.body.style.overflow = 'hidden'; // Prevent scrolling
      this.isOpen = true;
      
      // Trigger custom event
      document.dispatchEvent(new CustomEvent('ld-post-modal-opened', { detail: { post } }));
    },

    close: function() {
      if (!this.modal || !this.isOpen) return;
      
      // Hide modal
      this.modal.style.display = 'none';
      document.body.style.overflow = ''; // Restore scrolling
      document.body.style.paddingRight = ''; // Remove padding
      this.isOpen = false;
      
      // Trigger custom event
      document.dispatchEvent(new CustomEvent('ld-post-modal-closed'));
    },

    updateContent: function(post) {
      // Update images gallery
      this.setupImageGallery(post);
      
      // Update username
      const usernameElement = document.getElementById('ld-post-detail-username');
      if (usernameElement) {
        const userName = post.customer.name || 
                        `${post.customer.first_name || ''} ${post.customer.last_name || ''}`.trim() || 
                        'User';
        usernameElement.textContent = userName;
      }
      
      const dateElement = document.getElementById('ld-post-detail-date');
      const contentElement = document.getElementById('ld-post-detail-content');
      const productsTitleElement = document.getElementById('ld-post-detail-products-title');
      const productsContainer = document.getElementById('ld-post-detail-products');
      const productsSection = document.getElementById('ld-post-detail-products-container');
      const moreButton = document.getElementById('ld-post-detail-more');
      const likeCountElement = document.getElementById('ld-post-detail-like-count');
      const likeIconElement = document.getElementById('ld-post-detail-like-icon');
      const likesContainer = document.getElementById('ld-post-detail-likes');
      
      // Clear previous products
      productsContainer.innerHTML = '';
      
      // Set text content
      contentElement.textContent = post.content || '';
      
      // Format and set date
      if (post.create_at) {
        // "2025-08-19T12:30:01.671+08:00"
        const postDate = new Date(post.create_at);
        const formattedDate = postDate.toLocaleDateString('en-US', { 
          year: 'numeric', 
          month: 'short', 
          day: 'numeric' 
        });
        dateElement.textContent = formattedDate;
      } else {
        dateElement.textContent = '';
      }
      
      // Set like count
      if (likeCountElement) {
        likeCountElement.textContent = post.like_count || post.likes || 0;
      }
      
      // More button event listener is set up later in this function
      
      // Add products
      productsTitleElement.style.opacity = '0';
      if (post.products) {
        post.products.forEach(product => {
          productsTitleElement.style.opacity = '1';
          if (product.featured_image) {
            const productElement = document.createElement('div');
            productElement.className = 'ld-post-detail__product';
            
            const productImage = document.createElement('img');
            productImage.className = 'ld-post-detail__product-image';
            productImage.src = product.featured_image;
            productImage.alt = product.title || 'Product';
            productImage.width = 72;
            productImage.height = 72;
            
            const productInfoContainer = document.createElement('div');
            productInfoContainer.className = 'ld-post-detail__product-info';
            
            const productTitle = document.createElement('div');
            productTitle.className = 'ld-post-detail__product-title';
            productTitle.textContent = product.title || '';
            
            const productPrice = document.createElement('div');
            productPrice.className = 'ld-post-detail__product-price';
            productPrice.textContent = product.price ? `$${(product.price/100).toFixed(2)}` : '';
            
            productInfoContainer.appendChild(productTitle);
            productInfoContainer.appendChild(productPrice);
            
            productElement.appendChild(productImage);
            productElement.appendChild(productInfoContainer);
            
            // Make the product clickable
            if (product.url) {
              productElement.style.cursor = 'pointer';
              productElement.addEventListener('click', () => {
                window.location.href = product.url;
              });
            }
            
            productsContainer.appendChild(productElement);
          }
        });
      }
      
      // Update likes
      if (likeCountElement) {
        likeCountElement.textContent = post.like_count || '0';
      }
      
      if (likeIconElement) {
        if (post.liked) {
          likesContainer.classList.add('liked');
        } else {
          likesContainer.classList.remove('liked');
        }
      }
      
      // Setup like functionality
      if (likesContainer) {
        // Remove any existing event listeners
        const newLikesContainer = likesContainer.cloneNode(true);
        likesContainer.parentNode.replaceChild(newLikesContainer, likesContainer);
        
        // Add new event listener with proper this binding
        const self = this;
        newLikesContainer.addEventListener('click', function() {
          self.toggleLike();
        });
      }
      
      // Setup more button
      if (moreButton) {
        // Remove any existing event listeners
        const newMoreButton = moreButton.cloneNode(true);
        moreButton.parentNode.replaceChild(newMoreButton, moreButton);
        
        // Add new event listener to show report modal
        const self = this;
        newMoreButton.addEventListener('click', function() {
          self.showReportModal();
        });
      }
    },
    
    setupImageGallery: function(post) {
      if (!this.slider || !this.dotsContainer || !this.navButtons.nav) return;
      
      // Clear existing content
      this.slider.innerHTML = '';
      this.dotsContainer.innerHTML = '';
      
      // Get images from post
      this.images = [];
      if (post.images && post.images.length > 0) {
        this.images = post.images;
      } else if (post.image) {
        // Fallback for single image
        this.images = [{ url: post.image }];
      }
      
      if (this.images.length === 0) return;
      
      // Reset current index
      this.currentImageIndex = 0;
      
      // Create image elements
      this.images.forEach((image, index) => {
        const imgElement = document.createElement('img');
        imgElement.className = 'ld-post-detail__image';
        imgElement.src = image.url;
        imgElement.alt = post.title || `Post Image ${index + 1}`;
        imgElement.width = 400;
        imgElement.height = 600;
        imgElement.style.display = index === 0 ? 'block' : 'none';
        this.slider.appendChild(imgElement);
      });
      
      // Show/hide navigation based on image count
      if (this.images.length > 1) {
        this.navButtons.nav.style.display = 'flex';
        this.createDots();
        this.updateNavigation();
      } else {
        this.navButtons.nav.style.display = 'none';
        this.dotsContainer.style.display = 'none';
      }
    },
    
    createDots: function() {
      if (!this.dotsContainer) return;
      
      this.dotsContainer.innerHTML = '';
      
      if (this.images.length <= 1) {
        this.dotsContainer.style.display = 'none';
        return;
      }
      
      this.dotsContainer.style.display = 'flex';
      
      this.images.forEach((_, index) => {
        const dot = document.createElement('div');
        dot.className = 'ld-post-detail__dot';
        if (index === this.currentImageIndex) {
          dot.classList.add('active');
        }
        dot.addEventListener('click', () => this.goToImage(index));
        this.dotsContainer.appendChild(dot);
      });
    },
    
    updateNavigation: function() {
      if (!this.navButtons.prev || !this.navButtons.next) return;
      
      // Update button states
      this.navButtons.prev.disabled = this.currentImageIndex === 0;
      this.navButtons.next.disabled = this.currentImageIndex === this.images.length - 1;
      
      // Update button opacity for disabled state
      this.navButtons.prev.style.opacity = this.currentImageIndex === 0 ? '0.5' : '1';
      this.navButtons.next.style.opacity = this.currentImageIndex === this.images.length - 1 ? '0.5' : '1';
      
      // Update dots
      const dots = this.dotsContainer.querySelectorAll('.ld-post-detail__dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === this.currentImageIndex);
      });
    },
    
    previousImage: function() {
      if (this.currentImageIndex > 0) {
        this.goToImage(this.currentImageIndex - 1);
      }
    },
    
    nextImage: function() {
      if (this.currentImageIndex < this.images.length - 1) {
        this.goToImage(this.currentImageIndex + 1);
      }
    },
    
    goToImage: function(index) {
      if (index < 0 || index >= this.images.length || index === this.currentImageIndex) return;
      
      // Hide current image
      const currentImg = this.slider.children[this.currentImageIndex];
      if (currentImg) {
        currentImg.style.display = 'none';
      }
      
      // Show new image
      const newImg = this.slider.children[index];
      if (newImg) {
        newImg.style.display = 'block';
      }
      
      // Update current index
      this.currentImageIndex = index;
      
      // Update navigation
      this.updateNavigation();
    },
    
    toggleLike: function() {
      if (!this.currentPost) return;
      
      // Check if user is authenticated
      if (!window.LingdongBBS || !window.LingdongBBS.isAuthenticated()) {
        this.showAuthRequiredMessage();
        return;
      }
      
      const post = this.currentPost;
      
      // Store original state for rollback if needed
      const wasLiked = post.liked;
      const originalCount = post.like_count || post.likes || 0;
      
      // Optimistically update UI
      post.liked = !wasLiked;
      post.like_count = wasLiked ? Math.max(0, originalCount - 1) : originalCount + 1;
      
      // Update UI
      this.updateContent(post);
      
      // Call the togglePostLike function if available
      if (window.LingdongBBS && window.LingdongBBS.togglePostLike) {
        window.LingdongBBS.togglePostLike(post.id, wasLiked)
          .then(() => {
            // Success - UI already updated
            console.log(`Post ${post.liked ? 'liked' : 'unliked'} successfully`);
          })
          .catch((error) => {
            // Revert optimistic update on error
            post.liked = wasLiked;
            post.like_count = originalCount;
            this.updateContent(post);
            console.error('Error toggling post like:', error);
          });
      }
    },
    
    showAuthRequiredMessage: function() {
      if (window.LingdongBBS) {
        window.LingdongBBS.showAuthRequiredMessage('You need to be logged in to like posts.', window.location.href);
      } else {
        // Fallback for when LingdongBBS is not available
        if (window.confirm('You need to be logged in to like posts. Would you like to login?')) {
          window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.href);
        }
      }
    },
    
    isCurrentUserPostOwner: function(post) {
      // Check if user is authenticated
      if (!window.LingdongBBS || !window.LingdongBBS.isAuthenticated()) {
        return false;
      }
      
      // Get current user ID
      const currentUserId = window.LingdongBBS.getCurrentUserId();
      if (!currentUserId) return false;
      
      // Check if post has customer ID and it matches current user ID
      return post && post.customer && post.customer.id === currentUserId;
    },
    
    openEditForm: function() {
      if (!this.currentPost) return;
      
      // Close the detail modal
      this.close();
      
      // Open the edit form with the current post data
      if (typeof window.openPostForm === 'function') {
        window.openPostForm(this.currentPost);
      } else {
        console.error('openPostForm function not found');
      }
    },
    
    showReportModal: function() {
      if (!this.currentPost) return;
      
      const post = this.currentPost;
      const postId = post.id || '';
      const postContent = post.content || '';
      
      // Format the text to display and copy
      const formattedText = `PostID: ${postId}<br />Content: ${postContent}`;
      
      // Create HTML content for the report modal
      const reportContent = `
        <p>To report this content, copy the link below and email it to <a href="mailto:info@casabrews.com" style="color: #26CFCF; text-decoration: none;">info@casabrews.com</a> with a brief explanation of why it violates our guidelines or terms of service.</p>
        <div style="margin-top: 20px; display: flex; align-items: center;">
          <input id="report-post-url" type="text" value="${postId}" readonly style="flex-grow: 1; padding: 12px; border: 1px solid #ddd; border-radius: 4px; margin-right: 10px;">
          <button id="report-copy-button" style="width: 90px; height: 44px; border-radius: 56px; opacity: 1; padding: 12px 20px; background-color: #26CFCF; color: white; border: none; font-weight: 500; cursor: pointer;">Copy</button>
        </div>
      `;
      
      // Show the modal using LingdongModal
      if (window.LingdongModal && typeof window.LingdongModal.open === 'function') {
        window.LingdongModal.open({
          title: 'Report',
          content: reportContent,
          onCancel: () => {},
          onSubmit: () => {}
        });
        
        // Add event listener for copy button after modal is opened
        setTimeout(() => {
          const copyButton = document.getElementById('report-copy-button');
          const urlInput = document.getElementById('report-post-url');
          
          if (copyButton && urlInput) {
            copyButton.addEventListener('click', function() {
              // Use the already formatted text
              
              // Use clipboard API to copy the formatted text
              navigator.clipboard.writeText(formattedText).then(() => {
                // Optional: Show feedback that copy was successful
                copyButton.textContent = 'Copied!';
                setTimeout(() => {
                  copyButton.textContent = 'Copy';
                }, 1500);
              }).catch(err => {
                console.error('Failed to copy: ', err);
                
                // Fallback to older method
                urlInput.value = formattedText;
                urlInput.select();
                document.execCommand('copy');
              });
            });
          }
        }, 100);
      } else {
        // Fallback if modal is not available
        alert('To report this content, please email info@casabrews.com with the post ID: ' + postId);
      }
    },
  };

  // Initialize the modal
  LDPostModal.init();
  
  // Expose the modal to the global scope
  window.LDPostModal = LDPostModal;
});
